// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunk-" + chunkId + "." + "c595cf8b23b96e37a38f" + ".js";
};